import { useTranslation } from 'react-i18next';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { hasOwnMenu } from './customMenuHeads';
import type { IMenuRecordsPartProps } from './IMenuRecordsPartProps';
import { LibraryModeLinks } from './LibraryModeLinks';
import { libraryViewOf } from './libraryModes';
import { ModuleMenuGroups } from './ModuleMenuGroups';
import { moduleMenuLabels } from './moduleMenuLabels';
import { moduleMenuOf } from './moduleMenuOf';
import { kindOf, menuSectionsOf, sectionTypesOf, tableTypesOf } from './moduleSections';
import { RecordTypeGroups } from './RecordTypeGroups';
import { TablesGroup } from './TablesGroup';
import { TypeSection } from './TypeSection';

/**
 * Робота із записами в меню модуля (прототип v4): пункти подання-бібліотеки (база знань), далі власне меню модуля з метаданих
 * (`definition.menu`: аналітичні інструменти, конструктор законопроєктів), інакше розділ на кожен реалізований тип (модуль із дочірніми
 * таблицями) або групи головного типу; «Таблиці» — лише в модулях із власним меню прототипу (завдання, база знань), без власного меню модуля.
 */
export function MenuRecordsPart({ ws, moduleKey, module, main, moduleName, current, libraryLabel, openState }: IMenuRecordsPartProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings(moduleKey);
  const sections = menuSectionsOf(module);
  const typeSections = sectionTypesOf(module);
  const currentSection = typeSections.some((r) => r.key === current) ? current : main.key;
  const library = libraryViewOf(main);
  const ownMenu = moduleMenuOf(module, strings, moduleMenuLabels(strings.lang, moduleKey), moduleName);
  const tables = sections.tables && hasOwnMenu(moduleKey) && !ownMenu.length ? tableTypesOf(module, typeSections).filter((r) => kindOf(r) !== 'catalogue') : [];
  const groups = { ws, moduleKey, moduleName, planning: sections.planning, openState };
  const typeGroups = typeSections.length > 0
    ? typeSections.map((r) => <TypeSection key={r.key} {...groups} rt={r} current={r.key === currentSection} />)
    : <RecordTypeGroups {...groups} rt={main} />;
  return (
    <>
      {library && <LibraryModeLinks ws={ws} moduleKey={moduleKey} module={module} rtKey={main.key} view={library} homeLabel={libraryLabel} />}
      {ownMenu.length > 0
        ? <ModuleMenuGroups ws={ws} moduleKey={moduleKey} definition={module} groups={ownMenu} current={current ?? main.key} openState={openState} />
        : typeGroups}
      <TablesGroup ws={ws} moduleKey={moduleKey} recordTypes={tables} current={current} title={t('menu.tables')}
        groupedType={typeSections.length ? undefined : main.key} defaultOpen={typeSections.length === 0} openState={openState} />
    </>
  );
}
